module.exports = __webpack_public_path__ + "img/1080386857.dee03865.jpg";